import React, {lazy} from 'react';
import {Redirect} from 'react-router-dom';
import {useAuthFetch} from 'context/fetch-context';

import {UserProvider} from 'context/user-context';
import {FacilitiesProvider} from 'context/facilities/facilities-context';
import {DashboardProvider} from 'context/dashboard/dashboard-context';
import {ParkingBansProvider} from '../context/parkingBans/parkingBans-context';
import {GuestCardsProvider} from '../context/guestCards/guestCards-context';
import {AuthRoute} from 'App';

const ManageUsers = lazy(() => import('pages/ManageUsers'));
const FacilitiesView = lazy(() => import('pages/ManageFacilities/FacilitiesView'));
const ParkingBansView = lazy(() => import('pages/ManageParkingBans/ParkingBansView'));
const ManageAvailability = lazy(() => import('pages/ManageFacilities/ManageAvailability'));
const ManageFloor = lazy(() => import('pages/ManageFacilities/ManageFloors/ManageFloor'));
const Dashboard = lazy(() => import('pages/Dashboard'));
const GuestCards = lazy(() => import('pages/GuestCards/GuestCardOverview'));

const AdminRoutes = () => {
  const {isAdmin} = useAuthFetch();

  return (
    <>
      {isAdmin ? (
        <>
          <AuthRoute exact path="/facilities/:facilityId/availability">
            <ManageAvailability />
          </AuthRoute>
          <AuthRoute exact path="/facilities/add">
            <FacilitiesProvider>
              <ManageFloor />
            </FacilitiesProvider>
          </AuthRoute>
          <AuthRoute exact path="/facilities/:facilityId/edit">
            <FacilitiesProvider>
              <ManageFloor />
            </FacilitiesProvider>
          </AuthRoute>
          <AuthRoute exact path="/facilities">
            <FacilitiesView />
          </AuthRoute>
          <AuthRoute exact path="/parking-bans">
            <ParkingBansProvider>
              <UserProvider>
                <ParkingBansView />
              </UserProvider>
            </ParkingBansProvider>
          </AuthRoute>
          <AuthRoute path="/users">
            <UserProvider>
              <ManageUsers />
            </UserProvider>
          </AuthRoute>
          <AuthRoute exact path="/dashboard">
            <DashboardProvider>
              <Dashboard />
            </DashboardProvider>
          </AuthRoute>
          <AuthRoute exact path="/guest-cards">
            <GuestCardsProvider>
              <GuestCards />
            </GuestCardsProvider>
          </AuthRoute>
        </>
      ) : (
        <Redirect to="/" />
      )}
    </>
  );
};

export default AdminRoutes;
